import { useState, useEffect } from "react";
import { Plus } from "lucide-react";
import Button from "../../components/Button/Button";
import ChapterSection from "./ChapterSection";

const ChapterList = ({ initialChapters = [], onChaptersChange, removeChapterFunction }) => {
  const [chapters, setChapters] = useState(initialChapters);
  
  // Aggiorna lo stato quando cambiano i capitoli iniziali
  useEffect(() => {
    setChapters(initialChapters);
  }, [initialChapters]);

  // Funzione per aggiornare i capitoli e chiamare il callback di salvataggio
  const updateAndSave = (newChapters) => {
    setChapters(newChapters);
    if (onChaptersChange) {
      onChaptersChange(newChapters);
    }
  };

  // Aggiungi un nuovo capitolo alla fine dell'elenco
  const addNewChapter = () => {
    const newChapter = {
      title: "Nuovo Capitolo",
      subtitle: "Inserisci una descrizione",
      subchapters: [{ 
        title: "Nuovo Sottoparagrafo",
        subtitle: "Inserisci una descrizione" 
      }]
    };
    
    updateAndSave([...chapters, newChapter]);
  };

  // Aggiungi un nuovo capitolo dopo un capitolo specifico
  const addChapterAfter = (index) => {
    const newChapter = {
      title: "Nuovo Capitolo",
      subtitle: "Inserisci una descrizione",
      subchapters: [{ 
        title: "Nuovo Sottoparagrafo",
        subtitle: "Inserisci una descrizione" 
      }]
    };
    
    const updatedChapters = [...chapters];
    updatedChapters.splice(index + 1, 0, newChapter);
    updateAndSave(updatedChapters);
  };

  // Aggiorna un campo di un capitolo esistente
  const updateChapter = (chapterIndex, field, newValue) => {
    const updatedChapters = [...chapters];
    updatedChapters[chapterIndex] = {
      ...updatedChapters[chapterIndex],
      [field]: newValue
    };
    
    updateAndSave(updatedChapters);
  };

  // Aggiungi un sottoparagrafo a un capitolo
  const addSubchapter = (chapterIndex) => {
    const updatedChapters = [...chapters];
    
    // Se non esiste l'array dei sottoparagrafi, crealo
    if (!updatedChapters[chapterIndex].subchapters) {
      updatedChapters[chapterIndex].subchapters = [];
    }
    
    updatedChapters[chapterIndex].subchapters.push({
      title: "Nuovo Sottoparagrafo",
      subtitle: "Inserisci una descrizione"
    });
    
    updateAndSave(updatedChapters);
  };

  // Aggiorna un campo di un sottoparagrafo
  const updateSubchapter = (chapterIndex, subchapterIndex, field, newValue) => {
    const updatedChapters = [...chapters];
    
    updatedChapters[chapterIndex].subchapters[subchapterIndex] = {
      ...updatedChapters[chapterIndex].subchapters[subchapterIndex],
      [field]: newValue
    };
    
    updateAndSave(updatedChapters);
  };

  return (
    <div className="space-y-4">
      {chapters.map((chapter, chapterIndex) => (
        <div key={`chapter-${chapterIndex}`} className="space-y-2">
          <ChapterSection
            chapter={chapter}
            chapterIndex={chapterIndex}
            isEditMode={true}
            updateChapter={updateChapter}
            updateSubchapter={updateSubchapter}
            addSubchapter={addSubchapter}
            removeChapter={removeChapterFunction}
          />
          
          {/* Button to add a chapter right after this one */}
          <div className="flex justify-center pt-2">
            <Button
              onClick={() => addChapterAfter(chapterIndex)}
              type="bw"
              size="sm"
              text={`Aggiungi capitolo`}
              licon={<Plus size={14} />}
            />
          </div>
        </div>
      ))}
      
      {/* Button to add a chapter at the end */}
      {/* <div className="mt-4">
        <Button
          onClick={addNewChapter}
          width="full"
          type="bw"
          size="sm"
          text="Aggiungi nuovo capitolo"
          licon={<Plus size={16} />}
        />
      </div> */}
    </div>
  );
};

export default ChapterList;